// Static brand assets. Dynamic contact info lives in SettingsContext.
export const BRAND = {
  logoUrl: "/brand/logo.png",
};
